var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "DialogReportPaid__Component" }, [
    _c("div", { staticClass: "modal-card" }, [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v("תצוגה מקדימה לכרטיסייה " + _vm._s(_vm.id)),
        ]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
      ]),
      _c("section", { staticClass: "modal-card-body" }, [
        _c(
          "div",
          { staticClass: "DialogReportPaid__Component__Loading" },
          [
            _c("b-field", { attrs: { label: _vm.frontLabel } }, [
              _c(
                "div",
                { staticClass: "flip-card-side" },
                [
                  _vm.model.question
                    ? _c("div", {
                        domProps: { innerHTML: _vm._s(_vm.model.question) },
                      })
                    : _vm._e(),
                  _vm.model.detailedAnswer
                    ? _c("b-field", [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(_vm.model.detailedAnswer),
                          },
                        }),
                      ])
                    : _vm._e(),
                  _vm._l(_vm.frontSideItems, function (item, idx) {
                    return _c(
                      "div",
                      { key: `front-${idx}`, staticClass: "flip-card-item" },
                      [
                        item.contentTypeId === 1
                          ? _c("div", {
                              domProps: { innerHTML: _vm._s(item.textContent) },
                            })
                          : item.contentTypeId === 2
                          ? _c("img", { attrs: { src: item.imageUrl } })
                          : item.contentTypeId === 3
                          ? _c(
                              "div",
                              { staticClass: "flip-card-video-placeholder" },
                              [
                                _vm._v(
                                  " וידאו (id: " + _vm._s(item.videoId) + ") "
                                ),
                              ]
                            )
                          : item.contentTypeId === 4
                          ? _c("audio", {
                              attrs: { src: item.audioUrl, controls: "" },
                            })
                          : _vm._e(),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]),
            _vm.hasBackSide
              ? _c("b-field", { attrs: { label: _vm.backLabel } }, [
                  _c(
                    "div",
                    { staticClass: "flip-card-side" },
                    _vm._l(_vm.backSideItems, function (item, idx) {
                      return _c(
                        "div",
                        { key: `back-${idx}`, staticClass: "flip-card-item" },
                        [
                          item.contentTypeId === 1
                            ? _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(item.textContent),
                                },
                              })
                            : item.contentTypeId === 2
                            ? _c("img", { attrs: { src: item.imageUrl } })
                            : item.contentTypeId === 3
                            ? _c(
                                "div",
                                { staticClass: "flip-card-video-placeholder" },
                                [
                                  _vm._v(
                                    " וידאו (id: " + _vm._s(item.videoId) + ") "
                                  ),
                                ]
                              )
                            : item.contentTypeId === 4
                            ? _c("audio", {
                                attrs: { src: item.audioUrl, controls: "" },
                              })
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c("b-button", {
            attrs: { disabled: _vm.isLoading, label: "סגור" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }